(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["space-policy-premium"] && !Shopify.designMode) return;
  try {
    
  function initSpacePolicyPage(root) {
    if (!root || root.dataset.policyReady === 'true') return;
    root.dataset.policyReady = 'true';
    const content = root.querySelector('[data-policy-content]');
    const navigation = root.querySelector('[data-policy-toc]');
    const wrapper = root.querySelector('[data-policy-toc-wrap]');
    const showGlyphs = root.dataset.policyHeadingGlyphs === 'true';
    if (!content || !navigation) return;
    // The original policy body contains outdated stock "shape-*" illustrations.
    // Keep the policy text editable in Shopify, while removing only those legacy
    // decorative assets from the premium page treatment.
    content.querySelectorAll('img[src*="shape-"]').forEach((image) => {
      const illustrationBlock = image.closest('p');
      if (illustrationBlock) illustrationBlock.classList.add('space-policy-page__legacy-illustration');
      else image.classList.add('space-policy-page__legacy-illustration');
    });
    const headings = content.querySelectorAll('h2, h3');
    if (!headings.length) {
      if (wrapper) wrapper.classList.add('space-policy-page__toc-empty');
      return;
    }
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `space-policy-heading-${index}`;
      heading.classList.add('space-policy-page__section-heading');
      heading.dataset.policyIndex = String(index + 1).padStart(2, '0');
      heading.removeAttribute('align');
      const label = heading.textContent.toLowerCase();
      let glyph = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 3h9l3 3v15H6z"></path><path d="M9 11h6M9 15h5"></path></svg>';
      if (label.includes('payment')) glyph = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16v11H4z"></path><path d="M4 10h16M8 15h3"></path></svg>';
      if (label.includes('shipping')) glyph = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7h11v10H3zM14 10h4l3 3v4h-7z"></path><path d="M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path></svg>';
      if (label.includes('return') || label.includes('exchange') || label.includes('warranty')) glyph = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 8 7-4 7 4-7 4-7-4Z"></path><path d="M5 8v8l7 4 7-4V8M12 12v8"></path><path d="M8 14H3m0 0 2.5-2.5M3 14l2.5 2.5"></path></svg>';
      if (label.includes('cancel')) glyph = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8"></circle><path d="m9 9 6 6m0-6-6 6"></path></svg>';
      if (showGlyphs) heading.insertAdjacentHTML('afterbegin', `<span class="space-policy-page__section-glyph">${glyph}</span>`);
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      if (heading.tagName === 'H3') link.classList.add('space-policy-page__sub-link');
      navigation.appendChild(link);
    });
    if ('IntersectionObserver' in window) {
      const links = navigation.querySelectorAll('a');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => link.classList.remove('is-active'));
          const active = navigation.querySelector(`a[href="#${entry.target.id}"]`);
          if (active) active.classList.add('is-active');
        });
      }, { rootMargin: '-18% 0px -72% 0px' });
      headings.forEach((heading) => observer.observe(heading));
    }
  }
  document.querySelectorAll('[data-space-policy-page]').forEach(initSpacePolicyPage);
  document.addEventListener('shopify:section:load', (event) => {
    initSpacePolicyPage(event.target.querySelector('[data-space-policy-page]'));
  });

  function initSpacePolicyMotion(root) {
    if (!root || root.dataset.policyMotionReady === 'true') return;
    root.dataset.policyMotionReady = 'true';
    if (root.dataset.policyMotion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const items = root.querySelectorAll('.space-policy-page__layout, .space-policy-page__cta');
    if (!items.length) return;
    root.classList.add('space-policy-page--motion-ready');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  }
  document.querySelectorAll('[data-space-policy-page]').forEach(initSpacePolicyMotion);
  document.addEventListener('shopify:section:load', (event) => {
    initSpacePolicyMotion(event.target.querySelector('[data-space-policy-page]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["space-reseller-inquiry"] && !Shopify.designMode) return;
  try {
    
  function initSpaceReseller(root) {
    if (!root || root.dataset.resellerReady === 'true') return;
    root.dataset.resellerReady = 'true';
    root.querySelectorAll('[data-reseller-checkbox-group]').forEach((group) => {
      const field = group.closest('.space-reseller__field');
      const hidden = field ? field.querySelector('[data-reseller-checkbox-value]') : null;
      const checkboxes = group.querySelectorAll('[data-reseller-checkbox]');
      const requiredCheckbox = group.querySelector('[data-reseller-checkbox-required]');
      const syncCheckboxes = () => {
        const selected = Array.from(checkboxes).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
        if (hidden) hidden.value = selected.join(', ');
        if (requiredCheckbox) requiredCheckbox.setCustomValidity(selected.length ? '' : 'Please select at least one product.');
      };
      checkboxes.forEach((checkbox) => checkbox.addEventListener('change', syncCheckboxes));
      syncCheckboxes();
    });
    if (root.dataset.resellerMotion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const items = root.querySelectorAll('.space-reseller__benefit, .space-reseller__form-card');
    if (!items.length) return;
    root.classList.add('space-reseller--motion');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  }
  document.querySelectorAll('[data-space-reseller]').forEach(initSpaceReseller);
  document.addEventListener('shopify:section:load', (event) => initSpaceReseller(event.target.querySelector('[data-space-reseller]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["space-shopping-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-space-guide][data-guide-motion="true"]').forEach((guide) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const steps = guide.querySelectorAll('.space-guide__step');
    if (!steps.length) return;

    guide.classList.add('space-guide--motion-ready');
    if (!('IntersectionObserver' in window)) {
      steps.forEach((step) => step.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16 });

    steps.forEach((step) => observer.observe(step));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["space-terms-conditions"] && !Shopify.designMode) return;
  try {
    
  function initSpaceTermsToc(terms) {
    if (!terms || terms.dataset.termsTocReady === 'true') return;
    terms.dataset.termsTocReady = 'true';
    const content = terms.querySelector('[data-terms-content]');
    const links = terms.querySelectorAll('[data-terms-toc] a');
    const policies = terms.querySelectorAll('.space-terms__policy');
    if (!content || !links.length || !policies.length) return;
    const setActive = (id) => links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`));
    if (!('IntersectionObserver' in window)) { setActive(policies[0].id); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) setActive(entry.target.id); });
    }, { rootMargin: '-18% 0px -68% 0px' });
    policies.forEach((policy) => observer.observe(policy));
  }
  document.querySelectorAll('[data-space-terms]').forEach(initSpaceTermsToc);
  document.addEventListener('shopify:section:load', (event) => initSpaceTermsToc(event.target.querySelector('[data-space-terms]')));

  document.querySelectorAll('[data-space-terms][data-terms-motion="true"]').forEach((terms) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const items = terms.querySelectorAll('.space-terms__summary-card, .space-terms__policy');
    if (!items.length) return;
    terms.classList.add('space-terms--motion-ready');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14 });
    items.forEach((item) => observer.observe(item));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
